import {
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  HttpResponseValidator2d6ie1tmzg8fi as HttpResponseValidator,
  get_ExpectSuccessAttributeKey20jj5fup38v1g as get_ExpectSuccessAttributeKey,
} from './HttpCallValidator.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { save1hc0jjdmqj6mp as save } from '../call/SavedCall.mjs';
import { bodyAsText193cd91fn5h1t as bodyAsText } from '../statement/HttpResponse.mjs';
import { MalformedInputExceptionbvc6h5ij0ias as MalformedInputException } from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ValidateMark() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return ValidateMark;
}
var ValidateMark;
function get_LOGGER() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return LOGGER;
}
var LOGGER;
function addDefaultResponseValidation(_this__u8e3s4) {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  HttpResponseValidator(_this__u8e3s4, ($this$HttpResponseValidator) => {
    $this$HttpResponseValidator.expectSuccess_1 = _this__u8e3s4.expectSuccess_1;
    $this$HttpResponseValidator.validateResponse_cfyktb_k$(addDefaultResponseValidation$lambda$slambda());
    return Unit_instance;
  });
}
var ResponseExceptionClass;
function ResponseException() {
  if (ResponseExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(response, cachedResponseText) {
        return new.target.new_io_ktor_client_plugins_ResponseException_wt1r3m_k$(response, cachedResponseText);
      }
      static new_io_ktor_client_plugins_ResponseException_wt1r3m_k$(response, cachedResponseText) {
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"');
        captureStack($this, $this.$throwableCtor_4);
        $this.response_1 = response;
        return $this;
      }
    }
    initMetadataForClass($, 'ResponseException');
    ResponseExceptionClass = $;
  }
  return ResponseExceptionClass;
}
var RedirectResponseExceptionClass;
function RedirectResponseException() {
  if (RedirectResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.new_io_ktor_client_plugins_RedirectResponseException_f944gi_k$(response, cachedResponseText);
      }
      static new_io_ktor_client_plugins_RedirectResponseException_f944gi_k$(response, cachedResponseText) {
        var $this = this.new_io_ktor_client_plugins_ResponseException_wt1r3m_k$(response, cachedResponseText);
        captureStack($this, $this.$throwableCtor_5);
        $this.message_1 = 'Unhandled redirect: ' + response.get_call_wojxrb_k$().get_request_jdwg4m_k$().get_method_gl8esq_k$().value_1 + ' ' + response.get_call_wojxrb_k$().get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + '. ' + ('Status: ' + response.get_status_jnf6d7_k$().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      get_message_h23axq_k$() {
        return this.message_1;
      }
      get message() {
        return this.get_message_h23axq_k$();
      }
    }
    initMetadataForClass($, 'RedirectResponseException');
    RedirectResponseExceptionClass = $;
  }
  return RedirectResponseExceptionClass;
}
var ClientRequestExceptionClass;
function ClientRequestException() {
  if (ClientRequestExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.new_io_ktor_client_plugins_ClientRequestException_9feqdd_k$(response, cachedResponseText);
      }
      static new_io_ktor_client_plugins_ClientRequestException_9feqdd_k$(response, cachedResponseText) {
        var $this = this.new_io_ktor_client_plugins_ResponseException_wt1r3m_k$(response, cachedResponseText);
        captureStack($this, $this.$throwableCtor_5);
        $this.message_1 = 'Client request(' + response.get_call_wojxrb_k$().get_request_jdwg4m_k$().get_method_gl8esq_k$().value_1 + ' ' + response.get_call_wojxrb_k$().get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + ') ' + ('invalid: ' + response.get_status_jnf6d7_k$().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      get_message_h23axq_k$() {
        return this.message_1;
      }
      get message() {
        return this.get_message_h23axq_k$();
      }
    }
    initMetadataForClass($, 'ClientRequestException');
    ClientRequestExceptionClass = $;
  }
  return ClientRequestExceptionClass;
}
var ServerResponseExceptionClass;
function ServerResponseException() {
  if (ServerResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.new_io_ktor_client_plugins_ServerResponseException_wkde97_k$(response, cachedResponseText);
      }
      static new_io_ktor_client_plugins_ServerResponseException_wkde97_k$(response, cachedResponseText) {
        var $this = this.new_io_ktor_client_plugins_ResponseException_wt1r3m_k$(response, cachedResponseText);
        captureStack($this, $this.$throwableCtor_5);
        $this.message_1 = 'Server error(' + response.get_call_wojxrb_k$().get_request_jdwg4m_k$().get_method_gl8esq_k$().value_1 + ' ' + response.get_call_wojxrb_k$().get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + ': ' + (response.get_status_jnf6d7_k$().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      get_message_h23axq_k$() {
        return this.message_1;
      }
      get message() {
        return this.get_message_h23axq_k$();
      }
    }
    initMetadataForClass($, 'ServerResponseException');
    ServerResponseExceptionClass = $;
  }
  return ServerResponseExceptionClass;
}
function addDefaultResponseValidation$lambda$slambda() {
  return constructCallableReference((response, $completion) => orPromise($completion, function *($completion) {
    var expectSuccess = response.get_call_wojxrb_k$().get_attributes_dgqof4_k$().get_r696p5_k$(get_ExpectSuccessAttributeKey());
    var tmp;
    if (!expectSuccess) {
      get_LOGGER().trace_fti9bv_k$('Skipping default response validation for ' + response.get_call_wojxrb_k$().get_request_jdwg4m_k$().get_url_18iuii_k$().toString());
      return Unit_instance;
    }
    var statusCode = response.get_status_jnf6d7_k$().value_1;
    var originCall = response.get_call_wojxrb_k$();
    var tmp_0;
    if (statusCode < 300 || originCall.get_attributes_dgqof4_k$().contains_du0289_k$(get_ValidateMark())) {
      return Unit_instance;
    }
    // Inline function 'kotlin.apply' call
    var this_0 = yield* save(originCall, $completion);
    this_0.get_attributes_dgqof4_k$().put_gkntno_k$(get_ValidateMark(), Unit_instance);
    var exceptionCall = this_0;
    var exceptionResponse = exceptionCall.get_response_xlk07e_k$();
    var tmp_1;
    try {
      tmp_1 = yield* bodyAsText(exceptionResponse, VOID, $completion);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof MalformedInputException()) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = '<body failed decoding>';
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var exceptionResponseText = tmp_1;
    var exception = (300 <= statusCode ? statusCode <= 399 : false) ? RedirectResponseException().new_io_ktor_client_plugins_RedirectResponseException_f944gi_k$(exceptionResponse, exceptionResponseText) : (400 <= statusCode ? statusCode <= 499 : false) ? ClientRequestException().new_io_ktor_client_plugins_ClientRequestException_9feqdd_k$(exceptionResponse, exceptionResponseText) : (500 <= statusCode ? statusCode <= 599 : false) ? ServerResponseException().new_io_ktor_client_plugins_ServerResponseException_wkde97_k$(exceptionResponse, exceptionResponseText) : ResponseException().new_io_ktor_client_plugins_ResponseException_wt1r3m_k$(exceptionResponse, exceptionResponseText);
    get_LOGGER().trace_fti9bv_k$('Default response validation for ' + response.get_call_wojxrb_k$().get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + ' failed with ' + exception.toString());
    throw exception;
  }), 1);
}
var properties_initialized_DefaultResponseValidation_kt_akvzqt;
function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
  if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
    properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ValidateMark';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    ValidateMark = new (AttributeKey())(name, tmp$ret$1);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
  }
}
//region block: exports
export {
  addDefaultResponseValidation as addDefaultResponseValidation1d06vtgr9flaj,
};
//endregion

//# sourceMappingURL=DefaultResponseValidation.mjs.map
